export default __webpack_public_path__ + "static/media/info.620253b1.svg";